import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

const propTypes = {
  children: PropTypes.node.isRequired,
  className: PropTypes.string,
};

const Footer = ({ children, className }) => {
  const classes = classNames({
    'create-wizard-layout-footer': true,
    [className]: !!className,
  });

  return <div className={classes}>{children}</div>;
};

Footer.propTypes = propTypes;

export default Footer;
